import { axios, Response } from '../index'
import { Post } from './get-post-by-id'

const getGroupFixedPosts = (ownerId: string): Response<Post[]> => {
  return axios.get(`/v1/personas/posts/pinned`, {
    params: { ownerId }
  })
}

export default getGroupFixedPosts
